import { defaults } from 'chart.js';

export function applyChartTheme() {
  defaults.font.family = "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";
  defaults.font.size = 12;
  defaults.color = '#64748B';

  defaults.plugins.legend.labels.usePointStyle = true;
  defaults.plugins.legend.labels.padding = 16;
  defaults.plugins.legend.labels.font = {
    ...defaults.plugins.legend.labels.font,
    size: 11,
    weight: '500',
  };
  defaults.plugins.legend.labels.boxWidth = 8;
  defaults.plugins.legend.labels.boxHeight = 8;

  defaults.plugins.tooltip.backgroundColor = '#0F172A';
  defaults.plugins.tooltip.titleFont = {
    ...defaults.plugins.tooltip.titleFont,
    size: 12,
    weight: '600',
  };
  defaults.plugins.tooltip.bodyFont = {
    ...defaults.plugins.tooltip.bodyFont,
    size: 11,
  };
  defaults.plugins.tooltip.borderColor = '#334155';
  defaults.plugins.tooltip.borderWidth = 1;
  defaults.plugins.tooltip.cornerRadius = 8;
  defaults.plugins.tooltip.padding = { top: 8, bottom: 8, left: 12, right: 12 } as any;
  defaults.plugins.tooltip.displayColors = true;
  defaults.plugins.tooltip.boxPadding = 4;

  defaults.scale.grid.color = '#F1F5F9';
  defaults.scale.grid.drawBorder = false;
  defaults.scale.ticks.font = {
    ...defaults.scale.ticks.font,
    size: 11,
  };
}
